import { createMapper } from "../../utils/utils";
import { Option } from "../common";

export const MARITAL_STATUS: Option[] = [
  { value: "SINGLE", label: "Single" },
  { value: "MARRIED", label: "Married" },
  { value: "DIVORCED", label: "Divorced" },
  { value: "WIDOWED", label: "Widowed" },
  { value: "SEPARATED", label: "Separated" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "OTHER", label: "Other" },
  { value: "PREFER_NOT_TO_ANSWER", label: "Prefer Not To Answer" },
];



export const RELATIONSHIP_WITH_PATIENT: Option[] = [
  { value: "SELF", label: "Self" },
  { value: "ASSOCIATE", label: "Associate" },
  { value: "CARE_GIVER", label: "Care Giver" },
  { value: "CHILD", label: "Child" },
  { value: "EMERGENCY_CONTACT", label: "Emergency Contact" },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "EMPLOYER", label: "Employer" },
  { value: "EXTENDED_FAMILY", label: "Extended Family" },
  { value: "FATHER", label: "Father" },
  { value: "FOSTER_CHILD", label: "Foster Child" },
  { value: "FRIEND", label: "Friend" },
  { value: "GRANDCHILD", label: "Grandchild" },
  { value: "GRANDPARENT", label: "Grandparent" },
  { value: "GUARDIAN", label: "Guardian" },
  { value: "HANDICAPPED_DEPENDENT", label: "Handicapped Dependent" },
  { value: "LIFE_PARTNER", label: "Life Partner" },
  { value: "MANAGER", label: "Manager" },
  { value: "MOTHER", label: "Mother" },
  { value: "NATURAL_CHILD", label: "Natural Child" },
  { value: "NONE", label: "None" },
  { value: "OTHER", label: "Other" },
  { value: "OTHER_ADULT", label: "Other Adult" },
  { value: "OWNER", label: "Owner" },
  { value: "PARENT", label: "Parent" },
  { value: "SIBLING", label: "Sibling" },
  { value: "SISTER", label: "Sister" },
  { value: "SPOUSE", label: "Spouse" },
  { value: "STEPCHILD", label: "Stepchild" },
  { value: "TRAINER", label: "Trainer" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "WARD_OF_COURT", label: "Ward Of Court" },
];

export const EMERGENCY_CONTACT_RELATIONSHIP_WITH_PATIENT: Option[] = [
  { value: "ASSOCIATE", label: "Associate" },
  { value: "CARE_GIVER", label: "Care Giver" },
  { value: "CHILD", label: "Child" },
  { value: "EMERGENCY_CONTACT", label: "Emergency Contact" },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "EMPLOYER", label: "Employer" },
  { value: "EXTENDED_FAMILY", label: "Extended Family" },
  { value: "FATHER", label: "Father" },
  { value: "FOSTER_CHILD", label: "Foster Child" },
  { value: "FRIEND", label: "Friend" },
  { value: "GRANDCHILD", label: "Grandchild" },
  { value: "GRANDPARENT", label: "Grandparent" },
  { value: "GUARDIAN", label: "Guardian" },
  { value: "HANDICAPPED_DEPENDENT", label: "Handicapped Dependent" },
  { value: "LIFE_PARTNER", label: "Life Partner" },
  { value: "MANAGER", label: "Manager" },
  { value: "MOTHER", label: "Mother" },
  { value: "NATURAL_CHILD", label: "Natural Child" },
  { value: "NONE", label: "None" },
  { value: "OTHER", label: "Other" },
  { value: "OTHER_ADULT", label: "Other Adult" },
  { value: "OWNER", label: "Owner" },
  { value: "PARENT", label: "Parent" },
  { value: "SIBLING", label: "Sibling" },
  { value: "SISTER", label: "Sister" },
  { value: "SPOUSE", label: "Spouse" },
  { value: "STEPCHILD", label: "Stepchild" },
  { value: "TRAINER", label: "Trainer" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "WARD_OF_COURT", label: "Ward Of Court" },
];

export const EMERGENCY_CONTACT_RELATION_MAPPER = createMapper(
  EMERGENCY_CONTACT_RELATIONSHIP_WITH_PATIENT
);
